import React, {useEffect, useState} from 'react'
import {Image} from 'antd'
import {inject, observer} from 'mobx-react'
import {getMediaWallList, queryClientList} from '@apis'

const LastPhotos = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId} = userInfo
    const [clientList, setClientList] = useState([])

    // 获取节点信息
    async function queryMediaWallList() {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await getMediaWallList(params)
      if (res && res.data) {
        getClientList(res.data)
      }
    }

    // 获取节点监控信息
    async function getClientList(nodeList) {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await queryClientList(params)
      if (res && res.data) {
        let client = []
        nodeList.map(item => {
          res.data.data.map(value => {
            if(value.appCode == item.code) {
              client.push({
                ...value,
                id: item.id,
                name: item.name
              })
            }
          })
        })
        setClientList(client)
      }
    }

    useEffect(() => {
      queryMediaWallList()
      const swiper = new Swiper(".mySwiper", {
        slidesPerView: 4,
        initialSlide :1,
        loop: true,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
      })
    }, [])

    return (
      <div className="ck-lastPhotos">
        <div className="swiper mySwiper">
          <div className="swiper-wrapper">
            {
              clientList.map(item => (
                <div className='swiper-slide'>
                  <div className='client-name'>{item.name}--桌面状态</div>
                  <Image className='client-img' src={location.origin + "/security/" + item.lastPicPath}/>
                  <div className='client-time'>更新时间 {item.dateTime}</div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    )
  })
)

export default LastPhotos
